import { gql } from '@apollo/client';

export const ADD_REMITTANCE_NOTE = gql`
  mutation AddRemittanceNote($input: AddRemittanceNoteInput!) {
    addRemittanceNote(input: $input) {
      offeringID
      buyerCompanyID
      sellerCompanyID
      noteID
      dealID
      loanID
      fileName
      note
      authorID
      authorRole
      createdAt
      updatedAt
    }
  }
`;
